import { userConstants } from "../../constant";

export function wishlists(state = [], action) {
  switch (action.type) {
    case userConstants.GET_WISHLISTS:
      return {
        wishlists: action.payload,
      };
    default:
      return state;
  }
}
